import { Breadcrumb, Col } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled, { css } from 'styled-components';

export const PageWrap = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: 16px;
  color: ${({ theme }) => theme.primaryLight3};
  padding: 12px 32px 32px 32px;
  font-weight: 400;
  @media screen and (max-width: 991px) {
    padding: 4px 20px 20px;
  }
  @media screen and (max-width: 575px) {
    padding: 4px 13px 13px;
  }
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.mainPrimary};
    border-color: ${({ theme }) => theme.mainPrimary};
  }
  .form-check-input:focus {
    box-shadow: none;
  }
  .col-xxl-3 {
    @media screen and (min-width: 1400px) {
      width: 25%;
      flex: 0 0 auto;
    }
  }
`;

export const PageTitle = styled.h5`
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
  &.myActivity {
    margin-bottom: 28px;
  }
`;

export const FooterPagination = styled.div`
  padding: 0 32px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const RowSelect = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  white-space: nowrap;
  max-width: 360px;
  width: 100%;
`;

export const PageResult = styled.span`
  color: ${({ theme }) => theme.menuText};
  font-weight: 400;
`;

export const UserImg = styled.img`
  width: 46px;
  height: 46px;
  object-fit: cover;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.primaryLight};
`;

export const ShopMenu = styled.div`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  padding: 15px 0;
  overflow: hidden;
  ul {
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      color: ${({ theme }) => theme.secondaryLight};
      padding: 12px 30px;
      position: relative;
      font-size: 16px;
      cursor: pointer;
      &.active {
        color: ${({ theme }) => theme.mainPrimary};
        &:before {
          content: '';
          position: absolute;
          left: -3px;
          top: 5px;
          bottom: 5px;
          width: 8px;
          background-color: ${({ theme }) => theme.mainPrimary};
          border-radius: 0 15px 15px 0;
        }
      }
      svg {
        vertical-align: middle;
        margin-right: 10px;
      }
      span {
        font-weight: 400;
        vertical-align: middle;
      }
    }
  }
`;

export const Category = styled.span`
  color: ${({ color, theme, positive, negative }) =>
    theme[color] ??
    (positive ? theme.success4 : negative ? theme.danger2 : theme.badgeText)};
  background-color: ${({ theme, color, positive, negative }) =>
    theme[color] ??
    (positive ? theme.success4 : negative ? theme.danger2 : theme.badgeText)}1a;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: ${({ size }) => (size === 'lg' ? '16px' : '12px')};
  display: inline-block;
  position: relative;
  z-index: 2;
  line-height: normal;
`;

export const CategoryDistance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  @media screen and (max-width: 767px) {
    margin-bottom: 12px;
  }
  ${Category} {
    @media screen and (max-width: 767px) {
      padding: 10px 20px;
    }
  }
`;
export const Mile = styled.span`
  color: ${({ theme }) => theme.badgeText};
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const Truncate = styled.h6`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
`;
export const MarketCard = styled.div`
  background-color: ${({ theme }) => theme.white};
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 30px;
  border: 1px solid ${({ theme }) => theme.inputBorder};
  cursor: pointer;
  @media screen and (max-width: 767px) {
    margin-bottom: 16px;
  }
`;
export const CardImage = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.primaryLight};
  max-width: 100%;
  height: 207px;
  img {
    max-width: 100%;
    height: 207px;
    width: 100%;
    object-fit: cover;
  }
  svg {
    position: absolute;
    right: 0;
    top: 0;
    padding: 17px;
    background-color: #fff;
    width: 60px;
    height: 60px;
    border-radius: 0 0 0px 20px;
    color: ${({ theme }) => theme.primary};
    @media screen and (max-width: 767px) {
      width: 54px;
      height: 49px;
      padding: 14px;
    }
  }
`;
export const CardContent = styled.div`
  padding: 12px;
`;
export const MarketTitle = styled.h4`
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
  margin-bottom: 12px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 48px;
  @media screen and (max-width: 767px) {
    font-size: 16px;
    min-height: initial;
  }
`;
export const MarketPrice = styled.h3`
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
  margin-bottom: 12px;
  @media screen and (max-width: 767px) {
    font-size: 18px;
    line-height: 23px;
  }
`;
export const MarketUser = styled.div`
  padding: 12px 12px 0 12px;
  border-top: 1px solid ${({ theme }) => theme.inputBorder};
  margin-left: -12px;
  margin-right: -12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const MarketUserWrap = styled.div`
  display: flex;
  align-items: center;
  h4 {
    margin-bottom: 0;
    margin-left: 10px;
    color: ${({ theme }) => theme.primaryDark};
    font-weight: 500;
    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;
export const MessageIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.primary};
  text-align: center;
  flex: 0 0 32px;
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const FilterTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  h4 {
    font-weight: 500;
    font-size: 18px;
    margin-bottom: 0;
    line-height: 22px;
  }
  svg {
    path {
      stroke: ${({ theme }) => theme.primaryDark};
    }
  }
`;

export const BreadcrumbStyle = styled(Breadcrumb)`
  .breadcrumb {
    margin-bottom: 0;
  }
  .breadcrumb-item {
    font-size: 18px;
    line-height: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.primaryDark};
    a {
      color: ${({ theme }) => theme.primaryDark};
      text-decoration: none;
    }
    + .breadcrumb-item::before {
      color: ${({ theme }) => theme.primaryDark};
    }
    ${({ theme }) => css`
      @media (max-width: ${theme?.breakpoints?.sm}px) {
        font-size: 16px;
      }
    `}
  }
  &.forum-bread {
    .breadcrumb-item {
      font-size: 16px;
      font-weight: 600;
      color: ${({ theme }) => theme.body};
    }
  }
`;

export const FilterButtonOutside = styled.div`
  button {
    height: fit-content;
    line-height: normal;
  }
  button {
    margin-right: 12px;
  }
  button:last-child {
    margin-right: 0;
  }
  .filterDropdownBtn {
    margin-top: 12px;
  }
  .topicFilterRadioLabel {
    color: ${({ theme }) => theme.primaryDark};
    padding-top: 16px;
    &:last-child {
      padding-bottom: 0 !important;
    }
    font-weight: 500;
    div {
      margin-right: 4px !important;
    }
  }
`;
export const FilterField = styled.div`
  padding: 0px 0 16px 0;
  :first-child {
    padding: 12px 0 16px 0;
  }
  .checkbox-label {
    font-size: 14px;
  }
  h5 {
    margin-bottom: 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: ${({ theme }) => theme.primaryDark};
  }
  .range {
    margin-top: 36px;
    width: 100%;
  }
  :nth-last-child(2) {
    padding-bottom: 27px;
  }
  :last-child {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0 0;
    :before {
      position: absolute;
      content: '';
      height: 1px;
      left: -24px;
      right: -24px;
      background: ${({ theme }) => theme.inputBorder};
      top: 0;
    }
    h5 {
      margin-bottom: 0;
      cursor: pointer;
    }
    button {
      border-radius: 81px;
      line-height: normal;
      padding: 10px 20px;
      height: fit-content;
    }
  }
  .topics-filter-input {
    &::before {
      position: static;
    }
  }
`;

export const ImageOutside = styled.div`
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
    border-radius: 10px;
  }
  .product-slider-image {
    .swiper-slide {
      height: auto;
    }
    img {
      max-height: 628px;
      height: 100%;
      background-color: ${({ theme }) => theme.primaryLight};
      @media (max-width: 767px) {
        height: 350px;
      }
    }
  }
  .thumb-slider {
    margin-top: 20px;
    .swiper-wrapper {
      .swiper-slide {
        aspect-ratio: 1 / 1;
        img {
          height: 100%;
          background-color: ${({ theme }) => theme.primaryLight};
          object-fit: cover !important;
          @media screen and (max-width: 1199px) {
            height: 100%;
          }
        }
      }
    }
  }
`;

export const ItemMain = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 24px;
  border-radius: 8px;
  @media screen and (max-width: 767px) {
    padding: 12px;
  }
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.lightGray1};
  ${ImageOutside} {
    .product-slider-image {
      img {
        height: 478px;
        @media screen and (max-width: 767px) {
          height: 325px;
        }
      }
    }
  }
  @media screen and (max-width: 1199px) {
    flex-direction: column;
  }
`;
export const ItemImage = styled.div`
  height: 100%;
  max-width: 502px;
  width: 100%;
  padding-right: 24px;
  flex: 0 0 40%;
  @media screen and (max-width: 1199px) {
    max-width: 100%;
    padding-right: 0;
  }
`;

export const ItemDescription = styled.div`
  flex: 1;
  color: ${({ theme }) => theme.primaryDark};
  h2 {
    font-size: 30px;
    margin: 18px 0 8px;
    font-weight: 500;
    line-height: 32px;
    @media screen and (max-width: 767px) {
      font-size: 18px;
      margin: 12px 0 8px;
      line-height: 24px;
    }
  }
  .title-desc {
    font-size: 12px;
    margin-bottom: 18px;
    display: inline-block;
    font-weight: 500;
    line-height: 16px;
    color: ${({ theme }) => theme.placeholderColor};
  }
  .reviews {
    padding-left: 15px;
    border-left: 1px solid ${({ theme }) => theme.inputBorder};
    font-size: 14px;
    line-height: 17px;
  }
`;
export const IconBox = styled.div`
  border: 1px solid ${({ theme }) => theme.inputBorder};
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  position: relative;
  :first-child {
    margin-right: 12px;
  }
  svg {
    color: ${({ theme }) => theme.primary};
    height: 14px;
    width: 14px;
  }
`;
export const Rating = styled.div`
  padding: 5px 10px;
  background-color: ${({ theme }) => theme.bodyBg};
  border-radius: 20px;
  color: ${({ theme }) => theme.primaryDark};
  font-size: 14px;
  line-height: 24px;
  display: flex;
  align-items: center;
  margin-right: 15px;
`;
export const LocationMain = styled.div`
  margin: 17px 0 25px;
  font-size: 14px;
  svg {
    margin-right: 11px;
  }
`;
export const InnerItemDescription = styled.div`
  padding: 24px 0;
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #e3e3e3;
  h4 {
    margin-bottom: 16px;
    font-size: 18px;
    line-height: 23px;
    font-weight: 500;
    color: ${({ theme }) => theme.primaryDark};
    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
      margin-bottom: 8px;
    }
  }
  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 30px;
    opacity: 0.8;
    margin-bottom: 0;
    color: ${({ theme }) => theme.primaryDark};
    @media screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;
export const BuyProductPart = styled.div`
  padding-top: 24px;
  h4 {
    font-weight: 500;
    font-size: 18px;
    line-height: 23px;
  }
  .quantity-selector {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: 20px;
    button {
      height: 48px;
      width: 48px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 36px;
      padding: 0;
      font-weight: 100;
      :first-child {
        background-color: ${({ theme }) => theme.bodyBg};
        color: ${({ theme }) => theme.primaryDark};
        border-color: ${({ theme }) => theme.bodyBg};
        &:hover,
        &:focus,
        &:active {
          background-color: ${({ theme }) => theme.bodyBg} !important;
          border-color: ${({ theme }) => theme.bodyBg} !important;
        }
      }
    }
  }
`;
export const ItemAmount = styled.div`
  margin-top: 32px;
  @media screen and (max-width: 767px) {
    margin-top: 24px;
  }
  .amount-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 24px;
    span,
    h4 {
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 0;
    }
    :nth-last-child(2) {
      border-bottom: 1px solid #e3e3e3;
    }
    :last-child {
      padding-top: 24px;
      padding-bottom: 32px;
    }
  }
`;
export const FilterBar = styled.div`
  height: 9px;
  background-color: ${({ theme }) => theme.bodyBg};
  margin-top: 60px;
  margin-bottom: 20px;
`;
export const FilterBarLine = styled.div`
  height: 9px;
  border-radius: 4px;
  position: relative;
  background-color: ${({ theme }) => theme.primary};
  &:after {
    content: '';
    position: absolute;
    left: 100%;
    width: 16px;
    height: 16px;
    background: ${({ theme }) => theme.primary};
    transform: rotate(45deg);
    border-radius: 100%;
    top: -4px;
    box-shadow: 0 0 0 5px ${({ theme }) => theme.primary}66;
    margin-left: -6px;
  }
`;
export const FilterValueTooltip = styled.div`
  position: absolute;
  top: -55px;
  left: -50%;
  transform: translateX(-50%);
  color: ${({ theme }) => theme.body};
  font-weight: 400;
  font-size: 14px;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.bodyBg};
  white-space: nowrap;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 7px;
    height: 7px;
    background: ${({ theme }) => theme.bodyBg};
    transform: rotate(45deg);
    border-radius: 2px;
    bottom: -3px;
  }
`;
export const FilterCheckBox = styled.div`
  margin-bottom: 16px;
  &:last-child {
    margin-bottom: 5px;
  }
`;
export const FilterBarDistanceRange = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  font-weight: 400;
`;
export const ShareSocialICons = styled.div`
  position: absolute;
  right: -10px;
  top: 100%;
  margin-top: 15px;
  min-width: 195px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.borderColorLight};
  @media screen and (max-width: 767px) {
    min-width: 138px;
    padding: 10px 15px;
  }
  &:after {
    content: '';
    position: absolute;
    right: 16px;
    top: -8px;
    border-left: 1px solid ${({ theme }) => theme.borderColorLight};
    border-top: 1px solid ${({ theme }) => theme.borderColorLight};
    width: 15px;
    height: 15px;
    transform: rotate(45deg);
    background: ${({ theme }) => theme.white};
  }
  svg {
    padding: 5px 10px;
    width: auto;
    height: auto;
    @media screen and (max-width: 767px) {
      padding: 0px;
      width: 17px;
      height: 17px;
    }
  }
`;
export const ProductButton = styled.div`
  svg {
    vertical-align: -5px;
    path {
      fill: ${({ theme }) => theme.primary};
    }
  }
  .chat-button {
    padding: 8px 21px;
  }
`;
export const RelatedItemsTitle = styled.div`
  font-size: 24px;
  color: ${({ theme }) => theme.primaryDark};
  line-height: 24px;
  font-weight: 500;
  margin: 32px 0 24px;
  @media screen and (max-width: 767px) {
    margin: 24px 0 16px;
    font-size: 18px;
  }
`;
export const FilterBody = styled.div`
  max-height: 300px;
  overflow-y: auto;
  > div {
    &:last-child {
      display: block;
      padding: 0 0 16px 0;
      &:before {
        content: normal;
      }
    }
  }
`;

export const StyledInfiniteScroll = styled(InfiniteScroll)`
  padding-bottom: 50px;
`;
export const BrowseItemCard = styled(Col)`
  @media screen and (max-width: 900px) {
    width: 100%;
    flex: 0 0 auto;
  }
  @media screen and (max-width: 767px) {
    width: 50%;
    flex: 0 0 auto;
  }
  @media screen and (max-width: 660px) {
    width: 100%;
    flex: 0 0 auto;
  }
`;

export const MarketplaceStyled = {
  PageWrap,
  PageTitle,
  ShopMenu,
  FooterPagination,
  RowSelect,
  PageResult,
  UserImg,
  Category,
  Truncate,
  MarketCard,
  CardImage,
  CardContent,
  CategoryDistance,
  Mile,
  MarketTitle,
  MarketPrice,
  MarketUser,
  MessageIcon,
  MarketUserWrap,
  FilterTitle,
  BreadcrumbStyle,
  FilterButtonOutside,
  FilterField,
  ImageOutside,
  ItemMain,
  ItemImage,
  ItemDescription,
  IconBox,
  Rating,
  LocationMain,
  InnerItemDescription,
  BuyProductPart,
  ItemAmount,
  FilterBar,
  FilterBarLine,
  FilterValueTooltip,
  FilterCheckBox,
  FilterBarDistanceRange,
  ShareSocialICons,
  ProductButton,
  RelatedItemsTitle,
  FilterBody,
  StyledInfiniteScroll,
  BrowseItemCard,
};
